import { CHAOS_SPREAD } from '../cards/recursive/chaos-spread';
import { PANDEMIC } from '../cards/support/pandemic';
import { MIRROR } from '../cards/trap/mirror';
import type { EnemyTemplate } from './template';

/** HEX-23 archetype ported (ADR-0015 §4, §15). Legendary tier: 4×4 grid, 5 dice,
 * epic + at least one legendary, plus a trap (Mirror) per the §4 legendary
 * profile. The wisp graduates from a V1 nuisance to a boss-tier status spreader. */
export const WILL_O_WISP: EnemyTemplate = {
  id: 'will-o-wisp',
  name: 'Will-o-Wisp',
  glyph: '✺', // flickering spark — the ethereal wisp
  tier: 'legendary',
  hp: 50,
  loadout: [
    { card: CHAOS_SPREAD, origin: { row: 0, col: 0 }, rotated: false },
    { card: PANDEMIC, origin: { row: 2, col: 0 }, rotated: false },
    { card: MIRROR, origin: { row: 2, col: 2 }, rotated: false },
  ],
  drops: { gold: 15 },
};
